/* ============================================================
   LOOP STATION スマホ用ナビゲーション (2026-08-27)
   ------------------------------------------------------------
   PCの黒バー(#global_menu)の中身を、スマホのハンバーガーメニュー内に
   アコーディオンとして出す。メニューの内容は #global_menu ひとつが正で、
   ここでは複製して並べ替えるだけ。項目を増やしたら自動で反映される。

   ・Globo Mega Menu アプリは不要
   ・PCの表示には一切影響しない(767px以下でのみ動く)
   ============================================================ */
(function () {
  "use strict";

  var MQ = "(max-width: 989px)";        // Dawnのドロワー表示と同じ境界
  var BUILT = "loopMobNav";

  function text(el) {
    return (el && el.textContent ? el.textContent : "").replace(/\s+/g, " ").trim();
  }

  /* リンクの見出し文字を拾う。
     カテゴリによって <p> だったり <span> だったりするので順に当たる。 */
  function linkLabel(a) {
    return text(a.querySelector("p"))
      || text(a.querySelector("span"))
      || text(a)
      || (a.querySelector("img") ? (a.querySelector("img").getAttribute("alt") || "").trim() : "");
  }

  function buildNav(source) {
    var wrap = document.createElement("nav");
    wrap.id = BUILT;
    wrap.className = "loop-mnav";
    wrap.setAttribute("aria-label", "商品カテゴリー");

    var groups = source.querySelectorAll(":scope > ul > li");
    for (var i = 0; i < groups.length; i++) {
      var li = groups[i];
      var head = li.querySelector(".back-photo");
      var title = text(head);
      if (!title) continue;

      var links = li.querySelectorAll(".box a[href]");
      if (!links.length) {
        // 中身を持たない見出し(アパレル別注など、見出し自体がリンク)は1行で出す
        var solo = li.querySelector("a[href]") || (head && head.getAttribute("href") ? head : null);
        var href = solo ? solo.getAttribute("href") : null;
        if (!href) continue;
        var a = document.createElement("a");
        a.className = "loop-mnav__solo";
        a.href = href;
        a.textContent = title;
        wrap.appendChild(a);
        continue;
      }

      var det = document.createElement("details");
      det.className = "loop-mnav__group";

      var sum = document.createElement("summary");
      sum.className = "loop-mnav__head";
      sum.innerHTML = '<span>' + title + '</span><span class="loop-mnav__count">'
        + links.length + '</span><span class="loop-mnav__chev" aria-hidden="true">▾</span>';
      det.appendChild(sum);

      var list = document.createElement("ul");
      list.className = "loop-mnav__list";
      for (var j = 0; j < links.length; j++) {
        var src = links[j];
        var label = linkLabel(src);
        if (!label) continue;
        var img = src.querySelector("img");
        var item = document.createElement("li");
        var link = document.createElement("a");
        link.href = src.getAttribute("href");
        link.className = "loop-mnav__link";
        link.innerHTML =
          (img ? '<img src="' + img.getAttribute("src") + '" alt="" loading="lazy">' : '<span class="loop-mnav__dot"></span>')
          + "<span>" + label + "</span>";
        item.appendChild(link);
        list.appendChild(item);
      }
      det.appendChild(list);
      wrap.appendChild(det);
    }
    return wrap.children.length ? wrap : null;
  }

  function mount() {
    if (!window.matchMedia(MQ).matches) return;
    if (document.getElementById(BUILT)) return;

    var source = document.getElementById("global_menu");
    if (!source) return;

    // Dawnのドロワー内側。見つからない場合はドロワー直下に入れる
    var host = document.querySelector("#menu-drawer .menu-drawer__navigation")
      || document.querySelector("#menu-drawer .menu-drawer__inner-container")
      || document.querySelector("#menu-drawer");
    if (!host) return;

    var nav = buildNav(source);
    if (!nav) return;
    host.insertBefore(nav, host.firstChild);
  }

  function boot() {
    mount();
    // ドロワーは開いたときに中身が作られる場合があるので、開閉を監視する
    var d = document.querySelector("details.menu-drawer-container");
    if (d) d.addEventListener("toggle", function () { if (d.open) mount(); });
    var mq = window.matchMedia(MQ);
    if (mq.addEventListener) mq.addEventListener("change", mount);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
